<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.20006 7.40006C3.53143 6.95823 4.15823 6.86869 4.60006 7.20006L8.00006 9.75006L11.4001 7.20006C11.8419 6.86869 12.4687 6.95823 12.8001 7.40006C13.1314 7.84189 13.0419 8.46869 12.6001 8.80006L8.60006 11.8001C8.2445 12.0667 7.75561 12.0667 7.40006 11.8001L3.40006 8.80006C2.95823 8.46869 2.86869 7.84189 3.20006 7.40006Z"
      fill="#4A4A4A"
    />
  </svg>
</template>
<script>
export default {
  name: 'arrow-down',
};
</script>
